import {
  styled, Typography, TypographyProps,
} from '@mui/material';
import { kiwiGreen, sanguine } from '../../../../../../utils/colors';

interface StyledChipProps extends TypographyProps {
  isForbidden?: boolean;
  isDetected?: boolean;
}

const StyledChip = styled((props: StyledChipProps) => {
  const { isForbidden, isDetected, ...other } = props;
  return <Typography {...other} />;
})(({ isForbidden, isDetected }) => {
  const palette = isForbidden ? sanguine : kiwiGreen;
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    padding: '3px 9px',
    border: `1px solid ${palette[700]}`,
    borderRadius: 4,
    fontSize: 12.5,
    lineHeight: 1.25,
    ...(isDetected ? {
      backgroundColor: palette[300],
      color: palette[800],
      fontWeight: 600,
    } : {
      backgroundColor: 'white',
      color: palette[700],
      fontWeight: 400,
    }),
    '& svg': {
      fontSize: 11,
      display: 'block',
    },
  };
});

export default StyledChip;
